// extracted by mini-css-extract-plugin
export var clickableWrapper = "_27-2";
export var placeholderIcon = "_27-3";
export var thumbnailCanvas = "_27-1";
export var thumbnailWrapper = "_27-0";